import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import { useNotification } from "../../contexts";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import FormFooter from "../../components/FormFooter";
import { unFormatAmount } from "../../utils";
import {
  UNIT_INITIAL_VALUES,
  UNIT_LEASE_INITIAL_VALUES,
} from "../../constants/initialValues";
import {
  getPropertyUnit,
  addPropertyUnit,
  updatePropertyUnit,
  getPropertyUnitLeaseSettings,
  updatePropertyUnitLeaseSettings,
} from "../../services/units";
import { getInviteList } from "../../services/invites";
import FormHeader from "../../components/FormHeader";
import FormUnit from "../../components/FormUnit";
import FormUnitLease from "../../components/FormUnitLease";
import ShareDialog from "../../components/ShareDialog";

import { EVERYTHING_UNIT_FORM } from "../../constants/validation";

function Unit(props) {
  const history = useHistory();
  const { id, unitid } = props.match.params;
  const { dispatch } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [unit, setUnit] = useState();
  const [unitLeaseSettings, setUnitLeaseSettings] = useState();
  const [invite, setInvite] = useState(false);

  useEffect(() => {
    if (unitid) {
      getPropertyUnit(id, unitid).then((data) => {
        setUnit(data);
      });
      getPropertyUnitLeaseSettings(id, unitid).then((data) => {
        setUnitLeaseSettings(data);
      });
      getInviteList({ propertyId: id, unitId: unitid }).then((data) => {
        setInvite(data[0]);
      });
    } else {
      setUnit(UNIT_INITIAL_VALUES);
      setUnitLeaseSettings(UNIT_LEASE_INITIAL_VALUES);
    }
  }, [unitid]);

  useEffect(() => {
    if (unitid && unit && unitLeaseSettings) {
      setIsLoading(false);
    }
    if (!unitid) {
      setIsLoading(false);
    }
  }, [unit, unitLeaseSettings]);

  const onSubmit = (values) => {
    if (unitid) {
      updatePropertyUnit(id, unitid, values.unit).then((data) => {
        updatePropertyUnitLeaseSettings(
          id,
          unitid,
          values.unitLeaseSettings
        ).then((data) => {
          dispatch({
            type: "add",
            notifications: [{ title: "Unit saved with success" }],
          });
          history.push(`/property/${id}`);
        });
      });
    } else {
      addPropertyUnit(id, values.unit).then((unit) => {
        getPropertyUnitLeaseSettings(id, unit.id).then((leaseSettings) => {
          const theDate = new Date();
          const myNewDate = new Date(theDate);
          myNewDate.setDate(myNewDate.getDate() + 1);
          updatePropertyUnitLeaseSettings(id, unit.id, {
            ...leaseSettings,
            ...values.unitLeaseSettings,
          }).then((data) => {
            dispatch({
              type: "add",
              notifications: [{ title: "Unit added with success" }],
            });
            history.push(`/property/${id}`);
          });
        });
      });
    }
  };

  return (
    <Layout isLoading={isLoading}>
      <PageHeader title="Unit">
        {unitid && invite && (
          <ShareDialog propertyId={id} unitId={unitid} invite={invite} />
        )}
      </PageHeader>
      <Formik
        initialValues={{
          unit,
          unitLeaseSettings,
        }}
        validationSchema={EVERYTHING_UNIT_FORM}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box sx={{ gridArea: "main" }}>
              <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
                <FormHeader description="Complete the form below to add details to a unit" />
                <Grid container spacing={1}>
                  <FormUnit suffix="unit" />
                </Grid>
              </Paper>
              <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
                <FormHeader
                  title="Listing Lease Settings"
                  description="Complete the form below to create the lease setting for this unit"
                />
                <Grid container spacing={1}>
                  <FormUnitLease suffix="unitLeaseSettings" />
                </Grid>
              </Paper>
              <FormFooter onCancel={() => history.push(`/property/${id}`)} />
            </Box>
          </form>
        )}
      </Formik>
    </Layout>
  );
}

export default Unit;
